import { Lock } from "@mui/icons-material";
import {
  Alert,
  AlertColor,
  Box,
  Button,
  CircularProgress,
  CssBaseline,
  Dialog,
  DialogActions,
  Grid,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { baseURL, maskEmail } from "../utils/helper";
import { useTour } from "@reactour/tour";
interface Props {
  open: boolean;
  onClosingLoginModal: () => void;
  onLogin: (response: any) => void;
}
interface Toast {
  message: string;
  type: string;
}
function LoginModal(props: Props) {
  const { setIsOpen } = useTour();
  const { open, onClosingLoginModal } = props;
  const [userId, setUserId] = useState("");
  const [otp, setOtp] = useState("");
  const [disableOtp, setDisableOtp] = useState(false);
  const [reference, setReference] = useState("");
  const [disableLoginButton, setDisableLoginButton] = useState(true);
  const [displayToast, setDisplayToast] = useState<Toast>({
    message: "",
    type: "",
  });
  async function sendOtp() {
    setDisableOtp(true);
    let otpRequest = {
      strLoginId: userId,
      strPassword: "",
      strRef: "",
    };
    try {
      const getOtpResponse = await fetch(`${baseURL}/userauthmail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(otpRequest),
        credentials: "include",
      });
      const parsedResponse = await getOtpResponse.json();
      if (parsedResponse?.status === "Mail Sent Successfully") {
        sessionStorage.setItem("reference", parsedResponse?.reference);
        setDisableOtp(false);
        setReference(parsedResponse?.reference);
        setDisplayToast({
          message: `OTP sent Successfully to your mail ${maskEmail(
            parsedResponse?.mailid
          )}`,
          type: "success",
        });
        setDisableLoginButton(false);
      } else {
        setDisplayToast({
          message: parsedResponse?.status,
          type: "error",
        });
      }
    } catch (error: any) {
      console.log("Error in getting OTP", error, "Message", error.message);
    } finally {
      setDisableOtp(false);
    }
  }
  async function signIn() {
    const reference = sessionStorage.getItem("reference");
    let otpRequest = {
      strLoginId: userId,
      strPassword: otp,
      strRef: reference,
    };
    const getSignInResponse = await fetch(`${baseURL}/userauthenticate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(otpRequest),
      credentials: "include",
    });
    const parsedResponse = await getSignInResponse.json();
    if (parsedResponse?.userlogin === "success") {
      localStorage.setItem("user", JSON.stringify(parsedResponse));
      props.onLogin(parsedResponse);
      if (localStorage.getItem("isTourFinished") !== "yes") {
        setIsOpen(true);
        localStorage.setItem("isTourFinished", "yes");
      }
    }
  }
  return (
    <>
      <Dialog
        open={open}
        onClose={onClosingLoginModal}
        fullWidth={true}
        maxWidth="md"
      >
        <Box
          sx={{
            my: 2,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            alt="Not Found"
            src="/RIVA_new.png"
            style={{ height: 70, width: 70, borderRadius: "50%" }}
          ></img>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box sx={{ mt: 1 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="userid"
                label="Employee Id"
                autoFocus
                value={userId}
                inputProps={{ maxLength: 6 }}
                onChange={(event) => {
                  setUserId(event.target.value);
                }}
              />
              <Button
                type="button"
                variant="contained"
                onClick={sendOtp}
                disabled={disableOtp}
                sx={{
                  mt: 3,
                  mb: 2,
                  display: "flex",
                  backgroundColor: "#1A202C",
                }}
              >
                {disableOtp && <CircularProgress size={15} />}
                Get OTP
              </Button>
            </div>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Reference"
              type="text"
              id="reference"
              value={reference}
              disabled
              onChange={(event) => {
                setReference(event.target.value);
              }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="OTP"
              type="password"
              id="otp"
              value={otp}
              onChange={(event) => {
                setOtp(event.target.value);
              }}
            />

            <Button
              type="button"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                backgroundColor: "#1A202C",
              }}
              disabled={disableLoginButton}
              onClick={signIn}
            >
              Sign In
            </Button>
          </Box>
        </Box>
      </Dialog>
      <Snackbar
        open={Object.values(displayToast)[0].length > 0}
        autoHideDuration={10000}
        onClose={() => {
          setDisplayToast({ message: "", type: "" });
        }}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        key={"topright"}
      >
        <Alert
          onClose={() => {
            setDisplayToast({ message: "", type: "" });
          }}
          severity={displayToast.type as AlertColor}
          sx={{ width: "100%" }}
        >
          {displayToast.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default LoginModal;
